import { render, staticRenderFns } from "./thankyou.vue?vue&type=template&id=71ac0077&scoped=true&"
import script from "./thankyou.vue?vue&type=script&lang=js&"
export * from "./thankyou.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ac0077",
  null
  
)

export default component.exports